import { useTranslation } from 'react-i18next';

import { Input } from 'components/Form/Input/Input/Input';

export function CustomerOrderNumber({
  value,
  onChange,
  disabled,
}: {
  value?: string;
  onChange: (value: string) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <p className="text-base leading-6 font-bold text-gray-900">
        {t('orderForms:checkout.customerOrderNumber.label')}
      </p>
      <Input
        placeholder={t('orderForms:checkout.customerOrderNumber.placeholder')}
        description={t('orderForms:checkout.customerOrderNumber.helperText')}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </>
  );
}
